import styled from "styled-components";
import { ContentContainer } from "./ContentContainer";
import { Tag } from "./Tag";
import { MaterialIcon } from "../shared/MaterialIcon";

export const IndicatorCard = ({title, value, unit, icon, progress, type='default', ...restProps}) => {

    return (
        <StyledIndicatorCard
            padding="lg"
            contentGap="lg"
            contentOrientation="row"
            $type={type}
            {...restProps}
        >
            {
                icon ?
                <div className="iconContainer">
                    {icon}
                </div>
                : null
            }
            
            <div className="contentContainer">
                <div className="indicator">
                    <div className="value">
                        {value}
                        <span>{unit}</span>
                    </div>
                    {
                        progress ?
                        <Tag
                            type='success'
                            icon={<MaterialIcon name='moving' weight={300}/>}
                            text={progress}
                        /> : null
                    }
                    
                </div>
                <div className="title">
                    {title}
                </div>
            </div>
        </StyledIndicatorCard>
    )
}


const StyledIndicatorCard = styled(ContentContainer)`
    div.iconContainer
    {
        border: 1px solid ${({$type, theme}) => 
            $type === 'error' ? 'rgba(' + theme.colors.errorForegroundRGB + ', 0.15)' :
            $type === 'warning' ? 'rgba(' + theme.colors.warningForegroundRGB + ', 0.15)' :
            $type === 'success' ? 'rgba(' + theme.colors.successForegroundRGB + ', 0.15)' :
            $type === 'accent' ? 'rgba(' + theme.colors.accentForegroundRGB + ', 0.15)' :
            theme.colors.neutralPrimaryBorder
        };

        height: 100%;
        aspect-ratio: 1/1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        background: ${({$type, theme}) => 
            $type === 'error' ? theme.colors.errorBackground :
            $type === 'warning' ? theme.colors.warningBackground :
            $type === 'success' ? theme.colors.successBackground :
            $type === 'accent' ? theme.colors.accentBackground :
            theme.colors.neutralSecondaryBackground
        };
        
        .icon
        {
            font-size: ${({theme}) => theme.iconSize.xl};

            color: ${({$type, theme}) => 
                $type === 'error' ? theme.colors.errorForeground :
                $type === 'warning' ? theme.colors.warningForeground :
                $type === 'success' ? theme.colors.successForeground :
                $type === 'accent' ? theme.colors.accentForeground :
                theme.colors.neutralSecondaryForeground
            };
        }
    }

    div.contentContainer
    {
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
        div.indicator
        {
            display: flex;
            font-size: ${({theme}) => theme.fontSize.xxl};
            font-weight: 600;
            align-items: baseline;
            gap: ${({theme}) => theme.spacing.md};

            div span
            {
                font-size: ${({theme}) => theme.fontSize.xl};
                font-weight: 400;
            }
        }

        div.title
        {
            font-weight: 500;
            font-size: ${({theme}) => theme.fontSize.sm};
            color: ${({theme}) => theme.colors.mutedForeground};
        }
    }
`